// extracted by mini-css-extract-plugin
export default {"legends":"MultiBar_legends__Iui-y","legend":"MultiBar_legend__go0Rl","legendToggle":"MultiBar_legendToggle__ZbhKt","yLabel":"MultiBar_yLabel__z4OO4"};